import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components';

export const ForProfessionalsPage: React.FC = () => {
  const { t } = useTranslation('pages');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-[#0B1F3A]">{t('forProfessionals.title')}</h1>
        <p className="mt-4 text-xl text-gray-700 font-semibold">
          {t('forProfessionals.subtitle')}
        </p>
      </div>

      <div className="space-y-8 text-gray-700">
        <p className="text-lg">{t('forProfessionals.intro')}</p>

        <section className="space-y-4">
          <div>
            <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forProfessionals.visibility')}</h2>
            <p>{t('forProfessionals.visibilityText')}</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forProfessionals.convenience')}</h2>
            <p>{t('forProfessionals.convenienceText')}</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forProfessionals.appearance')}</h2>
            <p>{t('forProfessionals.appearanceText')}</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forProfessionals.collaboration')}</h2>
            <p>{t('forProfessionals.collaborationText')}</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forProfessionals.benefits')}</h2>
            <p>{t('forProfessionals.benefitsText')}</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#0B1F3A] mb-3">{t('forProfessionals.bigger')}</h2>
            <p>{t('forProfessionals.biggerText')}</p>
          </div>
        </section>

        <section className="bg-blue-50 p-6 rounded-lg">
          <p className="text-lg font-medium mb-4">{t('forProfessionals.summary')}</p>
        </section>

        <section className="text-center space-y-4 py-8">
          <p className="text-lg font-semibold text-gray-800">{t('forProfessionals.readyQuestion')}</p>
          <p className="text-lg text-gray-700">{t('forProfessionals.joinCta')}</p>
          <div className="pt-4">
            <Link to="/register">
              <Button size="lg" variant="primary">
                {t('forProfessionals.registerButton')}
              </Button>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};
